<template>
  <section class="product__section">
    <h2 class="product__section__heading">
      {{ title }}
    </h2>
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="product__section__text"
      v-html="show_full_content ? $sanitize(fullContent) : $sanitize(summary)"
    />
    <!-- eslint-enable vue/no-v-html -->
    <button
      v-if="summary != fullContent"
      class="product__section__show-more show-more-button"
      :class="{ 'show-more-button--close': show_full_content }"
      @click.prevent="toggle()"
    >
      {{ show_full_content ? $modeoL10n.hide : $modeoL10n.show_more }}
    </button>
  </section>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: '',
            },
            summary: {
                type: String,
                default: '',
            },
            fullContent: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                show_full_content: false,
            };
        },
        methods: {
            toggle : function() {
                this.show_full_content =! this.show_full_content;
            },
        },
    }
</script>
